"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_TAGS = exports.sanitizeString = exports.sanitizeXss = exports.sanitizeRichTextContent = void 0;
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const ALLOWED_TAGS = sanitize_html_1.default.defaults.allowedTags.concat([
    'span',
    'font',
    'field',
    'h1',
    'h2',
    'h3',
    'img',
    'colgroup',
    'col',
    'br',
]);
exports.ALLOWED_TAGS = ALLOWED_TAGS;
const sanitizeRichTextContent = (dirty, { allowedTags = ALLOWED_TAGS, allowedAttributes = {}, allowedClasses = null, removeImgSrc = false, removeIds = false, removeContentEditable = false, } = {}) => (0, sanitize_html_1.default)(dirty, {
    allowedTags,
    allowedAttributes: {
        a: ['href', 'target', 'rel'],
        span: [
            'style',
            'datatype',
            'data-id',
            'class',
            'data-entity',
            ...(removeContentEditable ? [] : ['contenteditable']),
        ],
        i: ['style', 'class'],
        div: ['class', 'style', 'data-pasted-html'],
        img: [...(removeImgSrc ? [] : ['src']), 'alt', 'style', 'width', 'height', 'data-link'],
        table: [
            'width',
            'class',
            'cellpadding',
            'cellspacing',
            'dir',
            'border',
            'style',
            'video-beat-data',
            ...(removeIds ? [] : ['id']),
        ],
        tr: ['style', 'class', 'colspan', 'valign', 'align', 'height', 'bgcolor', ...(removeIds ? [] : ['id'])],
        td: [
            'style',
            'rowspan',
            'width',
            'class',
            'colspan',
            'valign',
            'align',
            'height',
            'bgcolor',
            ...(removeIds ? [] : ['id']),
        ],
        tbody: ['style', 'class', ...(removeIds ? [] : ['id'])],
        font: ['color', 'style', 'class'],
        h1: ['style', 'class'],
        p: ['style', 'class', 'align'],
        li: ['style'],
        col: ['width', 'style', 'height'],
        colgroup: ['width', 'style', 'height'],
        field: [
            'class',
            'field_name',
            'field_type',
            'format_type',
            'format_pattern',
            'q',
            'type',
            'fallback',
            'belongs_to',
            'uid',
            'account_role',
            'owner_field',
            'dimension',
            'display_type',
            ...(removeContentEditable ? [] : ['contenteditable']),
        ],
        ...allowedAttributes,
    },
    ...(allowedClasses && { allowedClasses }),
});
exports.sanitizeRichTextContent = sanitizeRichTextContent;
const sanitizeXss = (html) => (0, sanitize_html_1.default)(html, {
    allowedTags: false,
    allowedAttributes: false,
    transformTags: {
        img: (tagName, { onerror, ...attribs }) => ({
            tagName,
            attribs,
        }),
    },
});
exports.sanitizeXss = sanitizeXss;
const sanitizeString = (string) => (0, sanitize_html_1.default)(string, {
    allowedTags: [],
    allowedAttributes: {},
});
exports.sanitizeString = sanitizeString;
//# sourceMappingURL=html-sanitizer.js.map